RivalIQ.apps.Site.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Renewal = Backbone.Model.extend({
        url: '/renew',
        validate: function (attrs) {
            const errors = [];

            if (!_.exists(attrs.accountId)) {
                errors.push(['accountId', 'accountId is required']);
            }

            if (!_.exists(attrs.choice)) {
                errors.push(['choice', 'renewal choice is required']);
            }

            if (!_.includes(['renew', 'help', 'decline'], attrs.choice)) {
                errors.push(['choice', `invalid choice: ${attrs.choice}`]);
            }

            if (attrs.choice === 'renew') {
                if (!_.exists(attrs.email)) {
                    errors.push(['email', 'email is required for renew']);
                }
            }

            if (attrs.choice === 'decline') {
                // 'whyCanceled', 'anotherTool', 'anotherToolName'
                if (!_.exists(attrs.whyCanceled)) {
                    errors.push(['whyCanceled', 'whyCanceled is required for decline']);
                }

                if (!_.exists(attrs.anotherTool)) {
                    errors.push(['anotherTool', 'anotherTool is required for decline']);
                }

                if (attrs.anotherTool === 'yes' && !_.exists(attrs.anotherToolName)) {
                    errors.push(['anotherToolName', 'anotherToolName is required for decline yes']);
                }
            }

            if (!errors.length) {
                return null;
            }

            return errors;
        }
    });
});
